import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, Link } from "react-router-dom";
import { MainState } from "../../Core/reducers";
import { Authorization, GlobalAuthorization } from "../../misc/components/Authorization";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Permission, QueryOrderDirection } from "../../misc/api/apiTypes";
import Condition from "../../misc/components/Condition";
import UserListTable from "./UserListTable";
import { useQueryTable, ClearFiltersAction, QueryTableState, PageAction, SetPageSizeAction } from "../../misc/components/queryTable/Hooks/UseQueryTable";
import { useSecurityContext } from "../../Core/SecurityContext";
import LoadingWithMessage from "../../misc/components/LoadingWithMessage";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

export interface UserListProps {
    currentStudyId: string;
}

export interface UserListRouteProps {
    didEmailFail: string;
    isSaveMessageDisplayed: string;
}

declare var rootUrl: string;

export const UserList = ({ currentStudyId, match }: UserListProps & RouteComponentProps<UserListRouteProps>) => {
    const { currentUserPermissions } = useSecurityContext();
    const [loaded, setLoaded] = React.useState(false);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getData = async () => {
            const tableParameters = await legacyClient.getTableParameters();

            dispatch(SetPageSizeAction.create(tableParameters.DefaultPageSize));
            setLoaded(true);
        }

        getData();
    }, []);

    const queryTableReducer = useQueryTable({
        query: {
            Page: {
                Current: 1,
                Length: 10,
            },
            Filters: [],
            Members: [],
            Order: {
                Member: 'Email',
                Direction: QueryOrderDirection.Ascending,
            }
        }
    });
    const [_, dispatch] = queryTableReducer;

    const menuItems = () => {
        const clearFilters = () => {
            dispatch(ClearFiltersAction.create());
        }

        return (
            <div className="ibox-tools">
                <Authorization permissionId={PermissionEnum.AssociateUsersWithSites}
                    studyId={currentStudyId}
                    currentPermissions={currentUserPermissions}
                >
                    <Link to="/users/associate" className="btn btn-primary">Associate with Sites</Link>
                </Authorization>
                <GlobalAuthorization permissionId={PermissionEnum.CreateUsers} currentPermissions={currentUserPermissions}>
                    <Link to="/users/create" className="btn btn-primary">Create New</Link>
                </GlobalAuthorization>
                &nbsp;
                <button className="btn btn-primary" onClick={clearFilters}>
                    Clear All Filters
                </button>
            </div>
        );
    }

    if (!loaded)
        return <LoadingWithMessage message="Loading Users List" />;

    return (
        <GlobalAuthorization currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.ViewUserManagement, PermissionEnum.ViewUsers]}>
        <div className="wrapper wrapper-content">
            {match.params.isSaveMessageDisplayed === "true" ?
                <div className="alert alert-success">
                    <i className="fas fa-check icon"></i> Saved successfully.
                </div>
                : null}
            {match.params.didEmailFail === "true" ?
                <div className="alert alert-warning">
                    <i className="fas fa-exclamation-circle"></i> The registration email was unable to be sent to the newly created user's email address, there may be an error with the email address. The user has still been saved.
                </div>
                : null}
            <div className="row">
                <div className="col-md-12">
                    <div className="ibox">
                        <div className="ibox-title">
                            <h2 className="text-primary">Users</h2>
                            {menuItems()}
                        </div>
                        <div className="ibox-content">
                            <div id="usersList">
                                <UserListTable queryTableReducer={queryTableReducer} />
                            </div>
                        </div>
                        <div className="ibox-footer">
                            {menuItems()}
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </GlobalAuthorization>
    );
}

function mapStateToProps(state: MainState) {
    return {
        currentStudyId: state.security.studyId,
    }
}

export default connect(mapStateToProps)(UserList);
